import Immutable from 'seamless-immutable';
import { SYSTEM_TYPES } from './actions';
import { createReducer } from '../../libs/saga-utils';

const DEFAULT_STATE = {
  isStarting: true
};

const ACTIONS = {
  [SYSTEM_TYPES.APP_STARTED]: appStarted
};

function appStarted(state, { payload }) {
  return state.set('isStarting', false);
}

// create the actual reducer
export default createReducer(Immutable(DEFAULT_STATE), ACTIONS);
